var loc = document.getElementsByClassName("js-accordion-location");
var i;

for (i = 0; i < loc.length; i++) {
    loc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
    });
}
